import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import DtoPutOrderPoolContainerTrailer_Addresses_Addresse from "./DtoPutOrderPoolContainerTrailer_Addresses_Addresse";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolContainerTrailer_Addresses extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.Addresses = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 提货地址与时间
     */
    Addresses?: DtoPutOrderPoolContainerTrailer_Addresses_Addresse[];
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolContainerTrailer_AddressesRules = {
}

/**
 * -设置项
 */
export const DtoPutOrderPoolContainerTrailer_AddressesMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Addresses",
    Label: "提货地址与时间",
    Customize: true,
  },
]
